module.exports = __webpack_public_path__ + "img/tabs-v2.0a714406.png";